import React, { useEffect, useState } from 'react'
import { useRouter } from 'react-router5';
import Screen from './Screen'
import { units } from '../db'
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import { red, green, blue, amber, purple, pink } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  avatar: {
    backgroundColor: red[500],
  },
}));

const colors = [red, green, blue, amber, purple, pink]

export default ({ onChooseModule }) => {
  const router = useRouter()
  const classes = useStyles()
  const takenChars = []
  let colorCursor = 0

  return (
    <Screen>
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, justifyContent: 'space-evenly' }}>
        <Typography variant="h5">Choose a module</Typography>

        {units.map(({ id, name }) => {
          const avatarChar = name.split('').map(x => x.toUpperCase()).find(x => !takenChars.includes(x))

          if (avatarChar) {
            takenChars.push(avatarChar)
          }

          const avatarColor = colors[colorCursor++]

          if (colorCursor >= colors.length) {
            colorCursor = 0
          }

          return (
            <Card
              key={id}
              onClick={() => onChooseModule(id)}
            >
              <CardHeader
                avatar={
                  <Avatar aria-label="recipe" style={{ backgroundColor: avatarColor[500] }}>
                    {avatarChar}
                  </Avatar>
                }
                title={name}
                style={{
                  cursor: 'pointer'
                }}
              />
            </Card>
          )
        })}

        <Button onClick={() => router.navigate('home')}>Cancel</Button>
      </div>
    </Screen>
  )
}